module.exports = __webpack_public_path__ + "static/no-hmd-256016b4850020263e94df86f1add327.gif";